import { FC, ReactElement } from 'react';

const ExpandableWrapper: FC = ({ children }) => children as ReactElement;

export default ExpandableWrapper;
